import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Slider } from '@/components/ui/slider';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { MapPin, Users, Calendar, Wallet, Gauge, Bus, Heart, Sparkles } from 'lucide-react';

export const ParamPanel = ({ params, setParams, onGenerate, loading }) => {
  return (
    <Card className="border-0 shadow-card rounded-card bg-white sticky top-24">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2 text-text-primary">
          <Sparkles className="w-5 h-5 text-primary" />旅行参数
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <MapPin className="w-4 h-4 text-primary" />
            目的地 <span className="text-danger">*</span>
          </Label>
          <Input
            placeholder="例如:大理、成都、日本"
            value={params.destination}
            onChange={(e) => setParams({ ...params, destination: e.target.value })}
            className="rounded-smwidget border-[#E8E4DF] bg-white text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-primary/20"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Calendar className="w-4 h-4 text-primary" />
            出行天数: <span className="text-primary font-semibold">{params.days}天</span>
          </Label>
          <Slider value={[params.days]} onValueChange={(v) => setParams({ ...params, days: v[0] })} min={1} max={15} step={1} className="py-2" />
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Users className="w-4 h-4 text-primary" />
            出行人数: <span className="text-primary font-semibold">{params.people}人</span>
          </Label>
          <Slider value={[params.people]} onValueChange={(v) => setParams({ ...params, people: v[0] })} min={1} max={10} step={1} className="py-2" />
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Wallet className="w-4 h-4 text-primary" />
            预算(元/人): <span className="text-primary font-semibold">¥{params.budget}</span>
          </Label>
          <Slider value={[params.budget]} onValueChange={(v) => setParams({ ...params, budget: v[0] })} min={500} max={20000} step={500} className="py-2" />
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Gauge className="w-4 h-4 text-primary" />
            节奏偏好
          </Label>
          <Select value={params.pace} onValueChange={(v) => setParams({ ...params, pace: v })}>
            <SelectTrigger className="rounded-smwidget border-[#E8E4DF] bg-white text-text-primary">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="relax">悠闲</SelectItem>
              <SelectItem value="moderate">适中</SelectItem>
              <SelectItem value="intense">紧凑</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Bus className="w-4 h-4 text-primary" />
            交通方式
          </Label>
          <Select value={params.transport} onValueChange={(v) => setParams({ ...params, transport: v })}>
            <SelectTrigger className="rounded-smwidget border-[#E8E4DF] bg-white text-text-primary">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="public">公共交通</SelectItem>
              <SelectItem value="drive">自驾</SelectItem>
              <SelectItem value="mixed">混合</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary flex items-center gap-2">
            <Heart className="w-4 h-4 text-primary" />
            旅行偏好
          </Label>
          <Select value={params.preference} onValueChange={(v) => setParams({ ...params, preference: v })}>
            <SelectTrigger className="rounded-smwidget border-[#E8E4DF] bg-white text-text-primary">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="sightseeing">景点打卡</SelectItem>
              <SelectItem value="nature">自然风光</SelectItem>
              <SelectItem value="culture">人文历史</SelectItem>
              <SelectItem value="food">美食探店</SelectItem>
              <SelectItem value="niche">小众秘境</SelectItem>
              <SelectItem value="family">亲子游</SelectItem>
              <SelectItem value="couple">情侣蜜月</SelectItem>
              <SelectItem value="hiking">户外徒步</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-text-primary">特殊需求</Label>
          <Textarea
            placeholder="例如:需要无障碍设施、素食餐厅等"
            value={params.special}
            onChange={(e) => setParams({ ...params, special: e.target.value })}
            className="rounded-smwidget border-[#E8E4DF] bg-white text-text-primary placeholder:text-text-tertiary min-h-[60px] focus:border-primary focus:ring-primary/20"
          />
        </div>

        <Button
          onClick={() => onGenerate()}
          disabled={loading}
          className="w-full bg-primary hover:bg-primary-hover text-white rounded-btn py-6 shadow-btn hover:shadow-btn-hover transition-all"
        >
          {loading ? '生成中...' : '生成行程'}
        </Button>
      </CardContent>
    </Card>
  );
};
